import { cn } from "@/lib/utils"
import { Input, InputProps } from "../ui/input"

export interface SearchInputProps extends InputProps {
  wrapperClassName?: string
}

function SearchInput({ wrapperClassName, ...props }: SearchInputProps) {
  return (
    <div className={cn("relative w-full max-w-xs", wrapperClassName)}>
      <IconHugeiconsSearch01 className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-secondary [&_path]:stroke-2" />
      <Input
        placeholder="Search"
        {...props}
        className={cn(
          `w-full max-w-xs rounded-xl border-none bg-card-hover pl-10 !text-sm placeholder:text-secondary focus-visible:bg-background`,
          props.className,
        )}
      />
    </div>

    // <TextInput
    //   leftSection={<IconMaterialSymbolsSearchRounded className="size-[18px]" />}
    //   placeholder="Search"
    //   variant="filled"
    //   {...props}
    //   className={cn(
    //     `
    //       w-full max-w-xs

    //       [&_input]:text-md
    //     `,
    //     props.className,
    //   )}
    // />
  )
}

export default SearchInput
